import { MESSAGE_TEMPLATES_LABEL } from '@app/constants';
import type {
  RecordsModuleKey,
  AnalyticsModuleKey,
  SalariesModuleKey,
  SalePlansModuleKey,
  BranchesModuleKey,
  ChainsModuleKey,
  ClientsModuleKey,
  IntegrationsModuleKey,
  LegalEntitiesModuleKey,
  PaymentAccountsModuleKey,
  UsersModuleKey,
  SalesRegisterModuleKey,
  AccessRightsModuleKey,
  LeadsModuleKey,
  DataMigrationsModuleKey,
  PositionsModuleKey,
  ClientServicesModuleKey,
  MessageTemplatesModuleKey,
  SendoutsModuleKey,
  OrganizationsModuleKey,
  CrmTasksModuleKey,
  WorkSchedulesModuleKey,
  RightsItem,
  AccordionListType,
  WarehouseModuleKey,
  ProductsModuleKey,
  TagsModuleKey,
  SalesFunnelsModuleKey,
  MedicalDocumentsModuleKey,
} from '@app/types/NewAccessRight';

export const recordAccordionItems: RightsItem<
  Exclude<RecordsModuleKey, 'IsOn'>
>[] = [
  {
    key: 'IsJournal',
    label: 'Журнал записей',
    dataTestId: 'calendar-records',
  },
  {
    key: 'IsRegister',
    label: 'Реестр записей',
    dataTestId: 'records-registry',
  },
  {
    key: 'IsStatuses',
    label: 'Смена статусов без ограничений',
    dataTestId: 'change-statuses',
  },
  {
    key: 'IsExport',
    label: 'Выгрузка записей в файл Excel',
    dataTestId: 'export-records',
  },
  {
    key: 'IsDelete',
    label: 'Удаление записей',
    dataTestId: 'delete-records',
  },
  {
    key: 'IsEdit',
    label: 'Редактирование записей',
    dataTestId: 'edit-records',
  },
  {
    key: 'IsCreate',
    label: 'Создание записей',
    dataTestId: 'create-records',
  },
  {
    key: 'IsViewAllRecords',
    label: 'Видимость всех записей',
    dataTestId: 'visibility-records',
  },
  {
    key: 'IsPayRecord',
    label: 'Оплата записи',
    dataTestId: 'payment-records',
  },
  {
    key: 'IsFinancialStatistics',
    label: 'Видимость финансовой статистики',
    dataTestId: 'visibility-financial-statistics',
  },
  {
    key: 'IsViewReminders',
    label: 'Видимость уведомлений клиентам',
    dataTestId: 'notification-settings',
  },
  {
    key: 'IsEditReminders',
    label: 'Редактирование уведомлений клиентам',
    dataTestId: '',
  },
  {
    key: 'IsEditPaidRecord',
    label: 'Редактирование оплаченной записи',
    dataTestId: 'edit-paid-record',
  },
  {
    key: 'IsViewPastRecords',
    label: 'Видимость записей предыдущих дней',
    dataTestId: '',
  },
];

export const analyticsRights: RightsItem<
  Exclude<AnalyticsModuleKey, 'IsOn'>
>[] = [
  {
    key: 'FinancialIncomesReport',
    label: 'Доходы филиала',
    dataTestId: 'financial-incomes-report',
  },
  {
    key: 'FinancialFactImplReport',
    label: 'Реализация филиала',
    dataTestId: 'financial-fact-impl-report',
  },
  {
    key: 'FinancialExpenseByArticlesReport',
    label: 'Детализация расходов филиала',
    dataTestId: 'financial-expense-by-article-report',
  },
  {
    key: 'FinancialPnlReport',
    label: 'Финансовые результаты филиала (PnL)',
    dataTestId: 'financial=pnl-report',
  },
  {
    key: 'FinancialDetailsOfExpensesReport',
    label: 'Расходы филиала',
    dataTestId: 'financial-details-of-expenses-report',
  },
  {
    key: 'FinancialBranchIndicatorsReport',
    label: 'Показатели филиалов',
    dataTestId: 'financial-branch-indicators-report',
  },
];

export const salariesRights: RightsItem<Exclude<SalariesModuleKey, 'IsOn'>>[] =
  [
    {
      key: 'EditBeforeConfirm',
      label: 'Редактирование до подтверждения',
      dataTestId: 'edit-before-confirm',
    },
    {
      key: 'EditAfterConfirm',
      label: 'Редактирование после подтверждения',
      dataTestId: 'edit-after-confirm',
    },
    {
      key: 'Confirm',
      label: 'Подтверждение начислений',
      dataTestId: 'confirm-salary',
    },
    {
      key: 'EditEmployeePayoff',
      label: 'Редактирование выплаты сотрудника',
      dataTestId: 'edit-employee-payoff',
    },
  ];

export const salesFunnelRights: RightsItem<
  Exclude<SalesFunnelsModuleKey, 'IsOn'>
>[] = [
  {
    key: 'IsFunnelCreate',
    label: 'Создание воронок продаж',
    dataTestId: 'is-funnel-create',
  },
  {
    key: 'IsFunnelEdit',
    label: 'Редактирование воронок продаж',
    dataTestId: 'is-funnel-edit',
  },
  {
    key: 'IsFunnelDelete',
    label: 'Удаление воронок продаж',
    dataTestId: 'is-funnel-delete',
  },
  {
    key: 'IsStageCreate',
    label: 'Создание этапов воронок продаж',
    dataTestId: 'is-stage-create',
  },
  {
    key: 'IsStageEdit',
    label: 'Редактирование этапов воронок продаж',
    dataTestId: 'is-stage-edit',
  },
  {
    key: 'IsStageDelete',
    label: 'Удаление этапов воронок продаж',
    dataTestId: 'is-stage-delete',
  },
];

export const paymentAccountsRights: RightsItem<
  Exclude<PaymentAccountsModuleKey, 'IsOn'>
>[] = [
  {
    key: 'IsCreate',
    label: 'Создание касс',
    dataTestId: 'create-payment-account',
  },
  {
    key: 'IsEdit',
    label: 'Редактирование касс',
    dataTestId: 'edit-payment-account',
  },
  {
    key: 'IsDelete',
    label: 'Удаление касс',
    dataTestId: 'delete-payment-account',
  },
];

export const chainsRights: RightsItem<Exclude<ChainsModuleKey, 'IsOn'>>[] = [
  {
    key: 'IsCreate',
    label: 'Создание сетей',
    dataTestId: 'create-chain',
  },
  {
    key: 'IsEdit',
    label: 'Редактирование сетей',
    dataTestId: 'edit-chain',
  },
];

export const branchesRights: RightsItem<Exclude<BranchesModuleKey, 'IsOn'>>[] =
  [
    {
      key: 'IsCreate',
      label: 'Создание филиалов',
      dataTestId: 'create-branch',
    },
    {
      key: 'IsEdit',
      label: 'Редактирование филиалов',
      dataTestId: 'edit-branch',
    },
  ];

export const usersRights: RightsItem<Exclude<UsersModuleKey, 'IsOn'>>[] = [
  {
    key: 'IsEmployees',
    label: 'Реестр исполнителей',
    dataTestId: 'employees-registry',
  },
  {
    key: 'IsCreate',
    label: 'Создание пользователей / исполнителей',
    dataTestId: 'create-user-employee',
  },
  {
    key: 'IsEdit',
    label: 'Редактирование пользователей / исполнителей',
    dataTestId: 'edit-user-employee',
  },
  {
    key: 'IsDelete',
    label: 'Удаление пользователей / исполнителей',
    dataTestId: 'delete-user-employee',
  },
  {
    key: 'IsExport',
    label: 'Выгрузка исполнителей в файл Excel',
    dataTestId: 'export-employees',
  },
  {
    key: 'IsImport',
    label: 'Создание исполнителей через файл Excel',
    dataTestId: 'create-employees-from-excel',
  },
  {
    key: 'IsUsers',
    label: 'Реестр пользователей',
    dataTestId: 'users-registry',
  },
  {
    key: 'IsChangeOwner',
    label: 'Наделение пользователя наивысшими правами (владелец)',
    dataTestId: 'grant-owner-rights',
  },
  {
    key: 'IsChangeBranches',
    label: 'Редактирование филиалов пользователя / исполнителя',
    dataTestId: 'edit-user-branch',
  },
];

export const clientsRights: RightsItem<Exclude<ClientsModuleKey, 'IsOn'>>[] = [
  {
    key: 'IsShowContacts',
    label: 'Просмотр контактных данных клиентов',
    dataTestId: 'view-client-contacts',
  },
  {
    key: 'IsCreate',
    label: 'Создание клиентов',
    dataTestId: 'create-clients',
  },
  {
    key: 'IsEdit',
    label: 'Редактирование клиентов',
    dataTestId: 'edit-clients',
  },
  {
    key: 'IsDelete',
    label: 'Удаление клиентов',
    dataTestId: 'delete-clients',
  },
  {
    key: 'IsExport',
    label: 'Выгрузка клиентов в файл Excel',
    dataTestId: 'export-clients',
  },
  {
    key: 'IsCommunicate',
    label: 'Переписка с клиентами',
    dataTestId: 'client-correspondence',
  },
  {
    key: 'IsViewCommunication',
    label: 'Просмотр переписки с клиентом',
    dataTestId: 'view-client-correspondence',
  },
  {
    key: 'IsTagsChange',
    label: 'Редактирование тегов',
    dataTestId: 'add-tags',
  },
];

export const legalEntitiesRights: RightsItem<
  Exclude<LegalEntitiesModuleKey, 'IsOn'>
>[] = [
  {
    key: 'IsCreate',
    label: 'Создание юридических лиц',
    dataTestId: 'create-legal-entity',
  },
  {
    key: 'IsEdit',
    label: 'Редактирование юридических лиц',
    dataTestId: 'edit-legal-entity',
  },
  {
    key: 'IsDelete',
    label: 'Удаление юридических лиц',
    dataTestId: 'delete-legal-entity',
  },
];

export const integrationsRights: RightsItem<
  Exclude<IntegrationsModuleKey, 'IsOn'>
>[] = [
  {
    key: 'IsCreate',
    label: 'Создание интеграций',
    dataTestId: 'create-integration',
  },
  {
    key: 'IsEdit',
    label: 'Редактирование интеграций',
    dataTestId: 'edit-integration',
  },
  {
    key: 'IsDelete',
    label: 'Удаление интеграций',
    dataTestId: 'delete-integration',
  },
];

export const salePlansRights: RightsItem<
  Exclude<SalePlansModuleKey, 'IsOn'>
>[] = [
  {
    key: 'IsCreate',
    label: 'Создание и редактирование планов продаж',
    dataTestId: 'create-edit-sales-plan',
  },
  {
    key: 'IsExport',
    label: 'Выгрузка плана продаж в файл Excel',
    dataTestId: 'export-sales-plan',
  },
];

export const salesRegisterRights: RightsItem<
  Exclude<SalesRegisterModuleKey, 'IsOn'>
>[] = [
  {
    key: 'IsCreateExpense',
    label: 'Создание расходов',
    dataTestId: 'create-expense',
  },
  {
    key: 'IsCreateCollection',
    label: 'Создание инкассаций',
    dataTestId: 'create-cash-collection',
  },
  {
    key: 'IsToppingUpCash',
    label: 'Пополнение касс',
    dataTestId: 'replenishment-payment-account',
  },
  {
    key: 'IsDeleteExpense',
    label: 'Удаление расходов',
    dataTestId: 'delete-expense',
  },
  {
    key: 'IsDeleteSale',
    label: 'Удаление платежей',
    dataTestId: 'delete-payment',
  },
  {
    key: 'IsDeleteCollection',
    label: 'Удаление инкассаций',
    dataTestId: 'delete-cash-collection',
  },
  {
    key: 'IsTopClientBalance',
    label: 'Пополнение баланса клиента',
    dataTestId: 'replenishment-client-balance',
  },
  {
    key: 'IsReturnMoney',
    label: 'Возврат денег с баланса клиента',
    dataTestId: 'refund-balance-client',
  },
  {
    key: 'IsExport',
    label: 'Выгрузка финансов в файл Excel',
    dataTestId: 'export-financials-excel',
  },
];

export const accessRightsRights: RightsItem<
  Exclude<AccessRightsModuleKey, 'IsOn'>
>[] = [
  {
    key: 'IsCreateTemplates',
    label: 'Создание шаблонов прав доступа',
    dataTestId: 'create-access-rights-template',
  },
  {
    key: 'IsDeleteTemplates',
    label: 'Удаление шаблонов прав доступа',
    dataTestId: 'delete-access-rights-template',
  },
  {
    key: 'EditingRightsWithinOpenRights',
    label:
      '⁠Возможность редактировать права только в рамках открытых пользователю прав',
    dataTestId: 'edit-rights-only-opened-rights',
  },
];

export const clientServicesRights: RightsItem<
  Exclude<ClientServicesModuleKey, 'IsOn'>
>[] = [
  {
    key: 'IsClientServices',
    label: 'Реестр услуг',
    dataTestId: 'services-registry',
  },
  {
    key: 'IsServiceCategories',
    label: 'Реестр категорий услуг',
    dataTestId: 'categories-registry',
  },
  {
    key: 'IsCreate',
    label: 'Создание услуг',
    dataTestId: 'create-service',
  },
  {
    key: 'IsEdit',
    label: 'Редактирование услуг',
    dataTestId: 'edit-service',
  },
  {
    key: 'IsDelete',
    label: 'Удаление услуг',
    dataTestId: 'delete-service',
  },
  {
    key: 'IsExport',
    label: 'Выгрузка услуг в файл Excel',
    dataTestId: 'export-services',
  },
  {
    key: 'IsImport',
    label: 'Редактирование услуг через файл Excel',
    dataTestId: 'edit-services-excel',
  },
  {
    key: 'IsCategoryCreate',
    label: 'Создание категорий услуг',
    dataTestId: 'create-category',
  },
  {
    key: 'IsCategoryEdit',
    label: 'Редактирование категорий услуг',
    dataTestId: 'edit-category',
  },
  {
    key: 'IsCategoryDelete',
    label: 'Удаление категорий услуг',
    dataTestId: 'delete-category',
  },
  {
    key: 'IsAttach',
    label: 'Назначение услуг исполнителям',
    dataTestId: 'assign-services-employees',
  },
];

export const positionsRights: RightsItem<
  Exclude<PositionsModuleKey, 'IsOn'>
>[] = [
  {
    key: 'IsCreate',
    label: 'Создание должностей',
    dataTestId: 'create-position',
  },
  {
    key: 'IsEdit',
    label: 'Редактирование должностей',
    dataTestId: 'edit-position',
  },
  {
    key: 'IsDelete',
    label: 'Удаление должностей',
    dataTestId: 'delete-position',
  },
];

export const dataMigrationsRights: RightsItem<
  Exclude<DataMigrationsModuleKey, 'IsOn'>
>[] = [
  {
    key: 'IsCreate',
    label: 'Создание миграций данных',
    dataTestId: 'create-migration',
  },
];

export const leadsRights: RightsItem<Exclude<LeadsModuleKey, 'IsOn'>>[] = [
  {
    key: 'IsDelete',
    label: 'Удаление лидов',
    dataTestId: 'delete-leads',
  },
  {
    key: 'IsOwnerChange',
    label: 'Смена ответственного',
    dataTestId: 'change-responsible',
  },
  {
    key: 'IsViewAll',
    label: 'Видимость лидов других ответственных',
    dataTestId: 'view-other-responsible',
  },
  {
    key: 'IsAllowSpam',
    label: 'Отправка лидов в спам',
    dataTestId: 'send-to-spam',
  },
  {
    key: 'IsTake',
    label: 'Принятие диалога',
    dataTestId: 'accept-dialog',
  },
  {
    key: 'IsSaleFunnelChange',
    label: 'Смена воронок продаж на чужих лидах',
    dataTestId: 'change-sales-funnel',
  },
  {
    key: 'IsCommunicate',
    label: 'Отправка сообщений в чужих лидах',
    dataTestId: 'send-message-to-other-leads',
  },
];

export const workSchedulesRights: RightsItem<
  Exclude<WorkSchedulesModuleKey, 'IsOn'>
>[] = [
  {
    key: 'IsScheduleView',
    label: 'Видимость графиков работы',
    dataTestId: '',
  },
  {
    key: 'IsCreate',
    label: 'Создание графиков работы',
    dataTestId: 'create-work-schedule',
  },
  {
    key: 'IsEdit',
    label: 'Редактирование графиков работы',
    dataTestId: 'edit-work-schedule',
  },
  {
    key: 'IsDelete',
    label: 'Удаление графиков работы',
    dataTestId: 'delete-work-schedule',
  },
  {
    key: 'IsEditPast',
    label: 'Редактирование графиков работы в прошлом',
    dataTestId: 'edit-work-schedule-in-the-past',
  },
  {
    key: 'IsDeletePast',
    label: 'Удаление графиков работы в прошлом',
    dataTestId: 'delete-work-schedule-in-the-past',
  },
  {
    key: 'IsCreateBreak',
    label: 'Добавление перерывов в Журнале записи',
    dataTestId: '',
  },
  {
    key: 'IsEditBreak',
    label: 'Изменение перерывов в Журнале записи',
    dataTestId: '',
  },
  {
    key: 'IsDeleteBreak',
    label: 'Удаление перерывов в Журнале записи',
    dataTestId: '',
  },
];

export const crmTasksRights: RightsItem<Exclude<CrmTasksModuleKey, 'IsOn'>>[] =
  [
    {
      key: 'IsViewAll',
      label: 'Просмотр задач других ответственных',
      dataTestId: 'view-tasks-other-executors',
    },
    {
      key: 'IsCreate',
      label: 'Создание задачи',
      dataTestId: 'create-task',
    },
    {
      key: 'IsAssign',
      label: 'Назначение задачи',
      dataTestId: 'task-assignment',
    },
    {
      key: 'IsEditAll',
      label: 'Редактирование задач других ответственных',
      dataTestId: 'edit-task-other-users',
    },
    {
      key: 'IsChangeStatus',
      label: 'Выполнение и возврат задач в работу',
      dataTestId: 'execute-task-return-to-work',
    },
    {
      key: 'IsDelete',
      label: 'Удаление задач',
      dataTestId: 'delete-task',
    },
  ];

export const sendoutsRights: RightsItem<Exclude<SendoutsModuleKey, 'IsOn'>>[] =
  [
    {
      key: 'IsCreate',
      label: 'Создание рассылок (и автоматический запуск после их создания)',
      dataTestId: 'create-sendouts',
    },
    {
      key: 'IsControl',
      label: 'Запуск и остановка рассылок',
      dataTestId: 'start-stop-sendouts',
    },
    {
      key: 'IsViewReceivers',
      label: 'Просмотр получателей рассылок',
      dataTestId: 'view-recipients-sendouts',
    },
    {
      key: 'IsEdit',
      label: 'Редактирование рассылок',
      dataTestId: 'edit-sendouts',
    },
  ];

export const organizationsRights: RightsItem<
  Exclude<OrganizationsModuleKey, 'IsOn'>
>[] = [
  {
    key: 'SecretLoginToOrganizationAccount',
    label: 'Секретный вход в аккаунт организации',
    dataTestId: 'organization-secret-login',
  },
];

export const messageTemplatesRights: RightsItem<
  Exclude<MessageTemplatesModuleKey, 'IsOn'>
>[] = [];

export const warehouseRights: RightsItem<
  Exclude<WarehouseModuleKey, 'IsOn'>
>[] = [
  {
    key: 'IsWarehouseCreate',
    label: 'Создание складов',
  },

  {
    key: 'IsWarehouseEdit',
    label: 'Редактирование складов',
  },
  {
    key: 'IsWarehouseDelete',
    label: 'Удаление складов',
  },
  {
    key: 'IsSupplierCreate',
    label: 'Создание поставщиков',
  },
  {
    key: 'IsSupplierEdit',
    label: 'Редактирование поставщиков',
  },
  {
    key: 'IsSupplierDelete',
    label: 'Удаление поставщиков',
  },
  {
    key: 'IsSuppliers',
    label: 'Справочник поставщиков',
  },
  {
    key: 'IsProductItemsAccept',
    label: 'Поступление товаров на склад',
  },
  {
    key: 'IsProductItemsDelete',
    label: 'Удаление товаров со склада',
  },
  {
    key: 'IsProductItemsDecomission',
    label: 'Списание товаров со склада',
  },
  {
    key: 'IsProductItemsMove',
    label: 'Перемещение товаров между складами',
  },
  {
    key: 'IsInventoryCreate',
    label: 'Создание инвентаризации',
  },
  {
    key: 'IsInventoryEdit',
    label: 'Редактирование инвентаризации',
  },
  {
    key: 'IsInventoryDelete',
    label: 'Удаление инвентаризации',
  },
  {
    key: 'IsInventoryComplete',
    label: 'Завершение инвентаризации',
  },
  {
    key: 'IsInventoryCompleting',
    label: 'Выполнение инвентаризации',
  },
  {
    key: 'IsInventoryReports',
    label: 'Просмотр отчета инвентаризации',
  },
  {
    key: 'IsViewAllWarehouses',
    label: 'Просмотр складов всех филиалов',
  },
  {
    key: 'IsExportWarehouseProductsToExcel',
    label: 'Право доступа на экспорт товаров склада в Excel',
  },
];

export const productsRights: RightsItem<Exclude<ProductsModuleKey, 'IsOn'>>[] =
  [
    {
      key: 'IsProductCategories',
      label: 'Справочник категорий товаров',
    },
    {
      key: 'IsProductCategoryCreate',
      label: 'Создание категорий товаров',
    },
    {
      key: 'IsProductCategoryEdit',
      label: 'Редактирование категорий товаров',
    },
    {
      key: 'IsProductCategoryDelete',
      label: 'Удаление категорий товаров',
    },
    {
      key: 'IsProductCreate',
      label: 'Создание товаров',
    },
    {
      key: 'IsProductEdit',
      label: 'Редактирование товаров',
    },
    {
      key: 'IsProductDelete',
      label: 'Удаление товаров',
    },
    {
      key: 'IsBrandCreate',
      label: 'Создание брендов',
    },
    {
      key: 'IsBrandEdit',
      label: 'Редактирование брендов',
    },
    {
      key: 'IsBrandDelete',
      label: 'Удаление брендов',
    },
    {
      key: 'IsBrands',
      label: 'Справочник брендов',
    },
  ];

export const tagsRights: RightsItem<Exclude<TagsModuleKey, 'IsOn'>>[] = [];

// Медицинские документы (СЭМД/ЕГИСЗ). Пока бэк не отдаёт блок
// MedicalDocuments в ModelAccessRights (us/10241), сохранение этих галочек
// не применяется — фронт живёт на дефолте «разрешено всё».
export const medicalDocumentsRights: RightsItem<
  Exclude<MedicalDocumentsModuleKey, 'IsOn'>
>[] = [
  {
    key: 'IsEdit',
    label: 'Создание и редактирование черновиков, отправка на подпись',
    dataTestId: 'medical-documents-edit',
  },
  {
    key: 'IsSign',
    label: 'Подписание документов',
    dataTestId: 'medical-documents-sign',
  },
  {
    key: 'IsSend',
    label: 'Отправка в РЭМД и смена статусов',
    dataTestId: 'medical-documents-send',
  },
  {
    key: 'IsViewAll',
    label: 'Просмотр документов всех врачей',
    dataTestId: 'medical-documents-view-all',
  },
];
export const accordionList: AccordionListType = [
  {
    key: 'Records',
    label: 'Записи',
    items: recordAccordionItems,
    isSection: true,
    dataTestId: 'records-section',
  },
  {
    key: 'Clients',
    label: 'Клиенты',
    items: clientsRights,
    isSection: true,
    dataTestId: 'clients-section',
  },
  {
    key: 'Leads',
    label: 'Лиды',
    items: leadsRights,
    isSection: true,
    tooltip: 'Модуль доступен только при включенном модуле «Клиенты»',
    dataTestId: 'leads-section',
  },
  {
    key: 'WorkSchedules',
    label: 'График работы',
    items: workSchedulesRights,
    isSection: true,
    dataTestId: 'work-schedule',
  },
  {
    key: 'Chains',
    label: 'Сети',
    items: chainsRights,
    isSection: true,
    dataTestId: 'chains-section',
  },
  {
    key: 'Branches',
    label: 'Филиалы',
    items: branchesRights,
    isSection: true,
    dataTestId: 'branches-section',
  },

  {
    key: 'Users',
    label: 'Пользователи / исполнители',
    items: usersRights,
    isSection: true,
    dataTestId: 'users-employees-section',
  },
  {
    key: 'ClientServices',
    label: 'Услуги',
    items: clientServicesRights,
    isSection: true,
    dataTestId: 'services-section',
  },
  {
    key: 'Positions',
    label: 'Должности',
    items: positionsRights,
    isSection: true,
    dataTestId: 'positions-section',
  },
  {
    key: 'LegalEntities',
    label: 'Юридические лица',
    items: legalEntitiesRights,
    isSection: true,
    dataTestId: 'legal-entities-section',
  },
  {
    key: 'PaymentAccounts',
    label: 'Кассы',
    items: paymentAccountsRights,
    isSection: true,
    dataTestId: 'payment-account-section',
  },
  {
    key: 'SalePlans',
    label: 'Планы продаж',
    items: salePlansRights,
    isSection: true,
    dataTestId: 'sales-plan-section',
  },
  {
    key: 'DataMigrations',
    label: 'Миграция данных',
    items: dataMigrationsRights,
    isSection: true,
    dataTestId: 'migration-section',
  },
  {
    key: 'Integrations',
    label: 'Интеграции',
    items: integrationsRights,
    isSection: true,
    dataTestId: 'integrations-section',
  },
  {
    key: 'SalesRegister',
    label: 'Финансы',
    items: salesRegisterRights,
    isSection: true,
    dataTestId: 'client-payment-section',
  },
  {
    key: 'Analytics',
    label: 'Аналитика',
    items: analyticsRights,
    isSection: true,
    dataTestId: 'analytics-section',
  },
  {
    key: 'Salaries',
    label: 'Заработная плата',
    items: salariesRights,
    isSection: true,
    dataTestId: 'salaries-section',
  },
  {
    key: 'SalesFunnels',
    label: 'Воронки продаж',
    items: salesFunnelRights,
    isSection: true,
    dataTestId: 'sales-funnels-section',
  },
  {
    key: 'CrmTasks',
    label: 'Задачи',
    items: crmTasksRights,
    isSection: true,
    dataTestId: 'tasks-list-section',
  },
  {
    key: 'AiOperator',
    label: 'ИИ-агент',
    items: [],
    isSection: true,
    dataTestId: 'ai-operator-section',
    tooltipDataTestId: 'ai-operator-hint',
  },
  {
    key: 'Sendouts',
    label: 'Рассылки',
    items: sendoutsRights,
    isSection: true,
    dataTestId: 'sendouts-section',
  },
  {
    key: 'Organizations',
    label: 'Организации',
    items: organizationsRights,
    isSection: true,
    dataTestId: 'organizations-section',
  },
  {
    key: 'Warehouse',
    label: 'Склад',
    items: warehouseRights,
    isSection: true,
    dataTestId: '',
  },
  {
    key: 'Products',
    label: 'Товары',
    items: productsRights,
    isSection: true,
    dataTestId: 'products-section',
  },
  {
    key: 'AccessRights',
    label: 'Права доступа',
    items: accessRightsRights,
    isSection: false,
    dataTestId: 'access-rights-section',
  },

  {
    key: 'History',
    label: 'История действий',
    items: [],
    isSection: false,
    dataTestId: 'history-actions-section',
  },
  {
    key: 'MessageTemplates',
    label: MESSAGE_TEMPLATES_LABEL,
    items: messageTemplatesRights,
    isSection: false,
    dataTestId: 'templates-section',
  },
  {
    key: 'Tags',
    label: 'Теги',
    items: tagsRights,
    isSection: true,
    dataTestId: '',
  },
  {
    key: 'MedicalDocuments',
    label: 'Медицинские документы (ЕГИСЗ)',
    items: medicalDocumentsRights,
    isSection: true,
    dataTestId: 'medical-documents-section',
  },
  {
    key: 'Loyalty',
    label: 'Лояльность',
    items: [],
    isSection: true,
    dataTestId: 'loyalty-section',
  },
  {
    key: 'OnlineRecording',
    label: 'Онлайн запись',
    items: [],
    isSection: true,
    dataTestId: 'online-recording-section',
  },
];
